
import Script from 'next/script';
import React from 'react';
export const DatadomRum = () => {
  const version = process.env.NEXT_PUBLIC_VERSION;
  return (
    <>
        <Script src="https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js" strategy="afterInteractive" />
        <Script id="datadog-rum-init" strategy="afterInteractive" dangerouslySetInnerHTML={{
          __html: `
            const domain = window.location.hostname;
            if (domain === 'myselogerpro.com') {
                if (window.DD_RUM) {
                  window.DD_RUM.init({
                  applicationId: '7d5b3bd3-b2de-4742-9389-54e0c96055ff',
                  clientToken: 'pube7025b44bddea5011389994a3460f459',
                  site: 'datadoghq.com',
                  service: 'hyperfaiseur',
                  env: 'prod', 
                  version: '${version}',
                  sessionSampleRate:  100,
                  sessionReplaySampleRate:0, 
                  trackUserInteractions: true,
                  trackResources: true,
                  trackLongTasks: true,
                  defaultPrivacyLevel: 'mask-user-input',
                  })
              }
            }
          `
      }} />
    </>
  );
};

export default DatadomRum;
